// // src/components/Credit/CreditTable.jsx
// // Component to display credit collection data in a table format

// import React from 'react';

// /**
//  * CreditTable Component
//  * Displays a list of credit collections in a table format
//  * 
//  * @param {Array} credits - Array of credit collection objects to display
//  * @param {Function} onEdit - Callback function when edit button is clicked
//  * @param {Function} onDelete - Callback function when delete button is clicked
//  * @param {boolean} isLoading - Whether data is currently loading
//  */
// const CreditTable = ({ credits, onEdit, onDelete, isLoading }) => {
//   /**
//    * Format date for display
//    * @param {string} dateString - Date string from backend
//    */
//   const formatDate = (dateString) => {
//     if (!dateString) return '-';
//     const date = new Date(dateString);
//     return date.toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric'
//     });
//   };

//   /**
//    * Handle edit button click
//    * @param {Object} credit - The credit item to edit
//    */
//   const handleEdit = (credit) => {
//     if (onEdit) {
//       onEdit(credit);
//     }
//   };

//   /**
//    * Handle delete button click
//    * @param {Object} credit - The credit item to delete
//    */
//   const handleDelete = (credit) => {
//     if (onDelete) {
//       onDelete(credit);
//     }
//   };

//   // Show loading state while data is being fetched
//   if (isLoading) {
//     return (
//       <div className="credit-data-table-container">
//         <table className="credit-data-table">
//           <thead>
//             <tr>
//               <th>ID</th>
//               <th>Code</th>
//               <th>Customer Name</th>
//               <th>Type</th>
//               <th>Sale Person</th>
              
//               <th>Credit Amount</th>
//               <th>Balance</th>
//               <th>Date</th>
//               <th>Status</th>
//             </tr>
//           </thead>
//           <tbody>
//             <tr>
//               <td colSpan="10" className="credit-loading">
//                 Loading credit data...
//               </td>
//             </tr>
//           </tbody>
//         </table>
//       </div>
//     );
//   }

//   // Show empty state if no credits match filter
//   if (!credits || credits.length === 0) {
//     return (
//       <div className="credit-data-table-container">
//         <table className="credit-data-table">
//           <thead>
//             <tr>
//               <th>ID</th>
//               <th>Code</th>
//               <th>Customer Name</th>
//               <th>Type</th>
//               <th>Sale Person</th>
             
//               <th>Credit Amount</th>
//               <th>Balance</th>
//               <th>Date</th>
//               <th>Status</th>
//             </tr>
//           </thead>
//           <tbody>
//             <tr>
//               <td colSpan="10" className="credit-empty-state">
//                 No credit records match the current filter.
//               </td>
//             </tr>
//           </tbody>
//         </table>
//       </div>
//     );
//   }

//   // Render the credit table with data
//   return (
//     <div className="credit-data-table-container">
//       <table className="credit-data-table">
//         <thead>
//           <tr>
//             <th>ID</th>
//             <th>Code</th>
//             <th>Customer Name</th>
//             <th>Type</th>
//             <th>Sale Person</th>
           
//             <th>Credit Amount</th>
//             <th>Balance</th>
//             <th>Date</th>
//             <th>Status</th>
//           </tr>
//         </thead>
//         <tbody>
//   {credits.map((credit) => (
//     <tr 
//       key={credit.id}
//       className={credit.status?.toUpperCase() === 'PAID' ? 'row-paid' : ''}
//     >
//       {/* ID */}
//       <td>{credit.id}</td>
      
//       {/* Code */}
//       <td>{credit.code || '-'}</td>
      
//       {/* Customer Name */}
//       <td>{credit.credit?.customer?.name || '-'}</td>
      
//       {/* Type */}
//       <td>{credit.typ || '-'}</td>
      
//       {/* Sale Person */}
//       <td>{credit.salePerson?.firstName || '-'}</td>
      
//       {/* Credit Amount */}
//       <td>{credit.credit?.amount ? `Rs ${credit.credit.amount.toFixed(2)}` : '-'}</td>
      
//       {/* Balance (Remaining Amount) */}
//       <td>{credit.credit?.remainingAmount !== undefined ? `Rs ${credit.credit.remainingAmount.toFixed(2)}` : '-'}</td>
      
//       {/* Date */}
//       <td>{formatDate(credit.createdAt)}</td>
      
//       {/* Status */}
//       <td>
//         <span className={`status-badge status-${credit.status?.toLowerCase()}`}>
//           {credit.status || '-'}
//         </span>
//       </td>
//     </tr>
//   ))}
// </tbody>
//       </table>
//     </div>
//   );
// };

// export default CreditTable;

// src/components/Credit/CreditTable.jsx
// Component to display credit collection data in a table format

import React from 'react';

/**
 * CreditTable Component
 * Displays a list of credit collections in a table format
 * 
 * @param {Array} credits - Array of credit collection objects to display
 * @param {Function} onEdit - Callback function when edit button is clicked
 * @param {Function} onDelete - Callback function when delete button is clicked
 * @param {boolean} isLoading - Whether data is currently loading
 */
const CreditTable = ({ credits, allFilteredData, onEdit, onDelete, isLoading }) => {
  /**
   * Format date for display
   * @param {string} dateString - Date string from backend
   */
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  /**
   * Handle edit button click
   * @param {Object} credit - The credit item to edit
   */
  const handleEdit = (credit) => {
    if (onEdit) {
      onEdit(credit);
    }
  };
  // Total credit amount for PENDING and PARTIAL only (across all filtered results)
const calculateTotalPendingCredit = () => {
  const data = allFilteredData || credits || [];
  return data
    .filter(credit => {
      const status = credit.status?.toUpperCase();
      return status === 'PENDING' || status === 'PARTIALLY_PAID';
    })
    .reduce((sum, credit) => sum + (credit.credit?.amount || 0), 0);
};

const totalPendingCredit = calculateTotalPendingCredit();
const pendingCount = (allFilteredData || credits || []).filter(c => {
  const s = c.status?.toUpperCase();
  return s === 'PENDING' || s === 'PARTIAL_PAID';
}).length;

  /**
   * Handle delete button click
   * @param {Object} credit - The credit item to delete
   */
  const handleDelete = (credit) => {
    if (onDelete) {
      onDelete(credit);
    }
  };

  // Show loading state while data is being fetched
  if (isLoading) {
    return (
      <div className="credit-data-table-container">
        <table className="credit-data-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Code</th>
              <th>Customer Name</th>
              <th>Type</th>
              <th>Sale Person</th>
              
              <th>Credit Amount</th>
              <th>Balance</th>
              <th>Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan="10" className="credit-loading">
                Loading credit data...
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  // Show empty state if no credits match filter
  if (!credits || credits.length === 0) {
    return (
      <div className="credit-data-table-container">
        <table className="credit-data-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Code</th>
              <th>Customer Name</th>
              <th>Type</th>
              <th>Sale Person</th>
             
              <th>Credit Amount</th>
              <th>Balance</th>
              <th>Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan="10" className="credit-empty-state">
                No credit records match the current filter.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  // Render the credit table with data
  return (
    
<>
<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      {/* Credit Amount Widget */}
      <div style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '12px',
      padding: '12px 20px',
      margin: '0 0 12px 0',
      width: 'fit-content',
      background: 'linear-gradient(135deg, #004080 0%, #2c417c 100%)',
      borderRadius: '10px',
      boxShadow: '0 4px 15px rgba(0,0,0,0.15)',
      border: '1px solid rgba(255,255,255,0.08)',
      }}>
        {/* Icon */}
        <div style={{
          width: '42px', height: '42px', borderRadius: '10px',
          background: 'rgba(255, 171, 96, 0.15)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
        }}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ffab60" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <path d="M12 6v6l4 2"/>
          </svg>
        </div>

        {/* Label + Value */}
        <div>
          <div style={{
            fontSize: '11px', fontWeight: '600', letterSpacing: '0.08em',
            textTransform: 'uppercase', color: 'rgba(255,255,255,0.45)', marginBottom: '2px',
          }}>
            Total Outstanding Credit (Pending &amp; Partial)
          </div>
          <div style={{
            fontSize: '22px', fontWeight: '700', color: '#ffab60',
            letterSpacing: '-0.02em', lineHeight: 1,
          }}>
            Rs {totalPendingCredit.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </div>
        </div>

        {/* Pill */}
        <div style={{ marginLeft: 'auto' }}>
          <span style={{
            display: 'inline-block', padding: '4px 12px', borderRadius: '20px',
            background: 'rgba(255, 171, 96, 0.12)', border: '1px solid rgba(255, 171, 96, 0.25)',
            fontSize: '12px', fontWeight: '600', color: '#ffab60',
          }}>
            {pendingCount} unpaid
          </span>
        </div>
      </div>
      </div>
    

    <div className="credit-data-table-container">
      
      <table className="credit-data-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Code</th>
            <th>Customer Name</th>
            <th>Type</th>
            <th>Sale Person</th>
           
            <th>Credit Amount</th>
            <th>Balance</th>
            <th>Date</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
  {credits.map((credit) => (
    <tr 
      key={credit.id}
      className={credit.status?.toUpperCase() === 'PAID' ? 'row-paid' : ''}
    >
      {/* ID */}
      <td>{credit.id}</td>
      
      {/* Code */}
      <td>{credit.code || '-'}</td>
      
      {/* Customer Name */}
      <td>{credit.credit?.customer?.name || '-'}</td>
      
      {/* Type */}
      <td>{credit.typ || '-'}</td>
      
      {/* Sale Person */}
      <td>{credit.salePerson?.firstName || '-'}</td>
      
      {/* Credit Amount */}
      <td>{credit.credit?.amount ? `Rs ${credit.credit.amount.toFixed(2)}` : '-'}</td>
      
      {/* Balance (Remaining Amount) */}
      <td>{credit.credit?.remainingAmount !== undefined ? `Rs ${credit.credit.remainingAmount.toFixed(2)}` : '-'}</td>
      
      {/* Date */}
      <td>{formatDate(credit.createdAt)}</td>
      
      {/* Status */}
      <td>
        <span className={`status-badge status-${credit.status?.toLowerCase()}`}>
          {credit.status || '-'}
        </span>
      </td>
    </tr>
  ))}
</tbody>
      </table>
    </div>
    </>
  );
};

export default CreditTable;
